import auth from './auth'
import home from './home'
import basic from './basic'
import customer from './customer'
import care from './care'
import order from './order'
import profile from './profile'

export default fetch => ({
  auth: auth(),
  basic: basic(fetch),
  customer: customer(fetch),
  care: care(fetch),
  order: order(fetch),
  home: home(fetch),
  profile: profile(fetch)
})
